'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var LocalStorage = require('../Utilities/LocalStorage.js');

const useLocalStorage = (key, defaultValue) => {
    const [value, setValue] = React.useState(() => LocalStorage.getLocalStorageValue(key) || defaultValue);
    React.useEffect(() => {
        LocalStorage.saveLocalStorageValue(key, value);
    }, [key, value]);
    return [value, setValue];
};

exports["default"] = useLocalStorage;
exports.useLocalStorage = useLocalStorage;
